import { type FunctionComponent, type MouseEventHandler } from 'react';
import classnames from 'classnames';
import { defineMessages, useIntl } from 'dibs-react-intl';
import ChevronLeft from 'dibs-icons/exports/ChevronLeft.ts';

import styles from './main.module.css';
import dibsCss from 'dibs-css';

type ModalBackButtonProps = {
    onClick: MouseEventHandler;
    className?: string;
    disabled?: boolean;
    dataTn?: string;
    backgroundColor?: 'translucentWhite';
};
const messages = defineMessages({
    label: {
        id: 'modal.ModalBackButton.label',
        defaultMessage: 'Back',
    },
});
export const ModalBackButton: FunctionComponent<ModalBackButtonProps> = ({
    className,
    onClick,
    disabled,
    dataTn,
    backgroundColor,
}) => {
    const intl = useIntl();

    const wrapperClass = classnames(
        dibsCss.absolute,
        dibsCss.topXsmall,
        dibsCss.leftXsmall,
        dibsCss.bgTransparent,
        dibsCss.borderNone,
        dibsCss.pXxsmall,
        dibsCss.fillNoir,
        className,
        disabled ? dibsCss.cursorNotAllowed : dibsCss.cursorPointer,
        {
            [styles.translucentWhite]: backgroundColor === 'translucentWhite',
        }
    );

    return (
        // this is a design system primitive, native button is intentional here
        // eslint-disable-next-line react/forbid-elements
        <button
            type="button"
            aria-label={intl.formatMessage(messages.label)}
            data-tn={dataTn || 'modal-back-button'}
            className={wrapperClass}
            onClick={disabled ? () => {} : onClick}
        >
            <ChevronLeft variation="24" dataTn="arrow-left" />
        </button>
    );
};
